import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { logout } from "../../redux/actions/authActions";

import OpenTextBookListComponent from './OpenTextBookListComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faVideo, 
    faPencil,  
    faBookReader,
    faDownload,
    faCrown
} from '@fortawesome/free-solid-svg-icons';
import './OpenTextBookHome.css';

function OpenTextBookHome() {
    const authState = useSelector((state) => state.authReducer || {});
    const isLogged = authState?.isLogged || false;
    const userName = authState?.user?.name || "User";

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };
    const [fetchData, { loading }] = useFetch();

    const [userId, setUserId] = useState(authState.user._id);
    const [bookId, setBookId] = useState("6703b08dd958602c3c46385b");
    const [isMOBook, setIsMOBook] = useState(false);
    const [isBookChecked, setIsBookChecked] = useState(false);

    const fetchMyBooks = useCallback(() => {
        const config = {
            url: "/mybooks/mobookbuyingstatus",
            method: "post",
            headers: { Authorization: authState.token },
            data: {userId: userId}
        };
    
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && typeof response.bookbuyingstatus === "boolean") {
                    setIsMOBook(response.bookbuyingstatus);
                } else {
                    console.error("Invalid response format: Book not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching MyBooks:", error);
            });
      }, [authState.token, fetchData]);
    
    
      useEffect(() => {
          if (!authState.isLoggedIn) return;
          fetchMyBooks();
      }, [authState.isLoggedIn, fetchMyBooks]);

    return (
         <div className="min-h-screen flex flex-col bg-black text-emerald-100 font-sans">
              <header className="sticky top-0 z-50 bg-black px-4 py-1 flex items-center justify-between shadow-lg border-b border-blue-400">
                <div className="flex flex-col">
                  <div className="text-xl lg:text-2xl font-bold text-yellow-200 flex items-center gap-1">
                    Open Cloud Notebook 
                  </div>
                  <div className="text-[11px] text-gray-200">
                    Create. Speak. Write. Capture. Upload. Access From Anywhere Anytime!
                  </div>
                </div>
                <div className="hidden md:flex items-center gap-3">
                  {isLogged ? (
                    <>
                      <div className="text-xs text-white">{userName}</div>
                      <button
                        onClick={handleLogout}
                        className="w-16 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                        title="Logout"
                      >
                        ⏻
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => navigate("/login")}
                        className="w-16 px-3 py-1 rounded-full border border-white text-sm hover:bg-white/10"
                      >
                        🔐
                      </button>
                    </>
                  )}
                </div>
        
                <button
                  onClick={() => setIsMobileMenuOpen((s) => !s)}
                  className="md:hidden w-10 h-10 flex items-center justify-center text-xl lg:text-2xl text-white"
                  aria-label="Toggle menu"
                >
                  {isMobileMenuOpen ? "×" : "☰"}
                </button>
              </header>
        
              {isMobileMenuOpen && (
                <div className="md:hidden bg-orange-900 border-b border-orange-800 px-4 py-3 animate-[fadeIn_0.3s_ease-in-out]">
                  {isLogged ? (
                    <div className="flex flex-col items-center gap-3">
                      <div className="text-xs text-white font-medium flex items-center gap-1">{userName}</div>
                      <button
                        onClick={handleLogout}
                        className="w-16 p-2 rounded-md bg-red-600 hover:bg-red-700"
                      >
                        ⏻
                      </button>
                    </div>
                  ) : (
                    <div className="flex justify-center gap-6">
                      <Link to="/login" className="w-16 text-white">🔐</Link>
                    </div>
                  )}
                </div>
              )}
            
            <div className="min-h-screen bg-black text-white [&_p]:text-white px-3 py-4">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    <Link
                    to={isMOBook ? "/opentextbook-pagelist" : "#"}
                    className={`rounded-xl p-3 shadow-md text-center transition ${
                        isMOBook
                        ? "bg-orange-500 hover:bg-orange-600 text-black"
                        : "bg-gray-300 text-gray-100 cursor-not-allowed"
                    }`}
                    >
                    <FontAwesomeIcon icon={faPencil} className="text-2xl mb-1" />
                    <p className="text-sm font-medium">My Pages</p>
                    </Link>

                    <Link
                    to={isMOBook ? "/flipbook" : "#"}
                    state={{ bookId: "6703b08dd958602c3c46385b" }}
                    className={`rounded-xl p-3 shadow-md text-center transition ${
                        isMOBook
                        ? "bg-red-600 hover:bg-red-700 text-white"
                        : "bg-gray-300 text-gray-100 cursor-not-allowed"
                    }`}
                    >
                    <FontAwesomeIcon icon={faBookReader} className="text-2xl mb-1" />
                    <p className="text-sm font-medium">FlipNotes</p>
                    </Link>

                    <Link
                    to={isMOBook ? "/videobook" : "#"}
                    state={{ bookId: "6703b08dd958602c3c46385b" }}
                    className={`rounded-xl p-3 shadow-md text-center transition ${
                        isMOBook
                        ? "bg-red-500 hover:bg-red-600 text-white"
                        : "bg-gray-300 text-gray-100 cursor-not-allowed"
                    }`}
                    >
                    <FontAwesomeIcon icon={faVideo} className="text-2xl mb-1" />
                    <p className="text-sm font-medium">VideoBook</p>
                    </Link>
                    <div className="col-span-2 sm:col-span-3 lg:col-span-4 mt-2">
                    <p className="text-xs text-white mb-2 text-center">
                        Premium Downloads
                    </p>

                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">

                        {[
                        "Download Book",
                        "Download Notes",
                        "Book + Notes",
                        ].map((item, i) => (
                        <div
                            key={i}
                            className="bg-lime-300 rounded-xl p-3 shadow text-center text-gray-100 opacity-90 cursor-not-allowed"
                        >
                            <FontAwesomeIcon icon={faDownload} className="text-xl mb-1" />
                            <p className="text-white text-xs font-medium flex items-center justify-center gap-1">
                            {item}
                            <sup>*</sup>
                            <FontAwesomeIcon icon={faCrown} className="text-yellow-500 text-xs" />
                            </p>
                        </div>
                        ))}

                    </div>
                    </div>
                </div>
                <div className="mt-5 bg-white/90 backdrop-blur rounded-xl p-3 shadow">
                    <OpenTextBookListComponent />
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-white py-2">
                <div className="px-3 flex flex-col lg:flex-row items-center justify-between gap-1">
                <div className="text-xs lg:text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
                <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                    <Link to="/about-us" className="text-white hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-teal-300">Contact</Link>
                </div>
                </div>
            </footer>            
    </div>
    );
}

export default OpenTextBookHome;
